import { parse } from 'date-fns';
import { z } from 'zod';

const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';

const parseDateTime = (date?: string, time?: string) => {
  if (!date || !time)
    return null;

  const parsed = parse(`${date} ${time}`, DATE_TIME_FORMAT, new Date());

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const auctionEntryUpdateDatesSchema = z
  .object({
    start_at_date: z.string().optional(),
    start_at_time: z.string().optional(),
    finish_at_date: z.string().optional(),
    finish_at_time: z.string().optional(),
  })
  .superRefine((values, ctx) => {
    const hasStartDate = !!values.start_at_date;
    const hasStartTime = !!values.start_at_time;
    const hasFinishDate = !!values.finish_at_date;
    const hasFinishTime = !!values.finish_at_time;

    if (hasStartDate !== hasStartTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Informe a data e o horário de início',
        path: [hasStartDate ? 'start_at_time' : 'start_at_date'],
      });
    }

    if (hasFinishDate !== hasFinishTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Informe a data e o horário de término',
        path: [hasFinishDate ? 'finish_at_time' : 'finish_at_date'],
      });
    }

    if (!hasStartDate && !hasStartTime && !hasFinishDate && !hasFinishTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Altere ao menos uma das datas do leilão',
        path: ['start_at_date'],
      });
    }

    const startAt = parseDateTime(values.start_at_date, values.start_at_time);
    const finishAt = parseDateTime(values.finish_at_date, values.finish_at_time);

    if (startAt && finishAt && finishAt <= startAt) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'A data de término deve ser posterior à data de início',
        path: ['finish_at_date'],
      });
    }
  });

export type AuctionEntryUpdateDatesValidationSchema = z.infer<typeof auctionEntryUpdateDatesSchema>;
